define('lq/formatter',[
    'globalize',
    'underscore',
    'lq/constants'
], function (globalize, _, constants) {
    'use strict';

    var getActualType = function (typeOfValue, value) {
        if (typeOfValue === constants.valueTypes.decimal)
            return typeOfValue;

        if (Object.prototype.toString.call(value) === '[object Number]') {
            if (value % 1 === 0) {
                return constants.valueTypes.integer;
            }
            return constants.valueTypes.decimal;
        }

        if (_.isDate(value))
            return constants.valueTypes.dateTime;

        if (typeOfValue)
            return typeOfValue;

        return constants.valueTypes.string;
    };

    // WHY: globalize keeps every culture that is added for good, a culture per formatter grew without limit (every page
    // creates its formatters again); formatters with the same base culture and separators share their culture.
    // The separators are in the name as character codes: globalize.culture() splits a name on ',' and ';' and trims it
    var getCultureId = function (baseCulture, formatting) {
        var toCharCodes = function (separator) {
            return _.map(String(separator).split(''), function (character) {
                return character.charCodeAt(0);
            }).join('.');
        };

        return ['lq', baseCulture.name, toCharCodes(formatting.groupSeperator), toCharCodes(formatting.decimalSeperator)].join('-');
    };

    var Formatter = function (formatting, userLanguage) {
        var baseCulture = globalize.findClosestCulture(userLanguage);
        var cultureId = getCultureId(baseCulture, formatting);
        if (!globalize.cultures[cultureId]) {
            globalize.addCultureInfo(cultureId, baseCulture, {
                name: cultureId,
                englishName: cultureId,
                nativeName: cultureId,
                language: cultureId
            });
            var culture = globalize.cultures[cultureId];
            culture.numberFormat[','] = formatting.groupSeperator;
            culture.numberFormat['.'] = formatting.decimalSeperator;
            culture.calendars.standard['/'] = '/'; // this will force globalize.js to use the seperator we give it, instead of defaulting to the seperator defined by the culture
        }
        this.culture = globalize.culture(cultureId);

        this.dateFormat = formatting.dateFormat;
        this.decimalPrecision = formatting.decimalPrecision;
        this.groupSeperator = formatting.groupSeperator;
        this.decimalSeperator = formatting.decimalSeperator;
        this.looseDateFormat = formatting.dateFormat.replace(/[^dMymhHsftzg]/g, '');
    };

    Formatter.prototype.convertFromLicquidFormat = function (typeOfValue, value) {
        var self = this;
        typeOfValue = getActualType(typeOfValue, value);

        if (typeOfValue === constants.valueTypes.dateTime) {
            if (value) {
                var theDate = _.isDate(value)
                    ? value
                    : self.parseLicquidDate(value);
                if (!theDate)
                    return value;

                try {
                    return this.formatDate(theDate);
                }
                catch (err) { // should not break the whole page for format string errors that the user can easily cause
                    return value;
                }
            }

            return value;
        }

        if (typeOfValue === constants.valueTypes.decimal || typeOfValue === constants.valueTypes.integer) {
            if (value === null || value === undefined || value === '')
                return null;

            if (Object.prototype.toString.call(value) !== '[object Number]')
                value = Number(value);

            // Even if the type is integer we still force the decimal precision if it's set
            if (typeOfValue === constants.valueTypes.decimal || this.decimalPrecision > 0)
                return globalize.format(value, "n" + this.decimalPrecision, this.culture);

            return globalize.format(value, "n0", this.culture);
        }

        if (typeOfValue === constants.valueTypes['boolean'])
            return value ? 'true' : 'false';

        return value;
    };

    Formatter.prototype.convertToLicquidFormat = function (typeOfValue, value) {
        var self = this;
        typeOfValue = getActualType(typeOfValue, value);

        if (value) {
            if (typeOfValue === constants.valueTypes.dateTime) {
                var theDate = globalize.parseDate(value, this.dateFormat);
                return self.formatLicquidDate(theDate);
            }

            if (typeOfValue === constants.valueTypes.decimal || typeOfValue === constants.valueTypes.integer) {
                if (Object.prototype.toString.call(value) === '[object Number]')
                    return value;

                if (typeOfValue === constants.valueTypes.decimal)
                    return globalize.parseFloat(value, 10, this.culture);

                return globalize.parseInt(value, 10, this.culture);
            }
        }

        return value;
    };

    Formatter.prototype.formatLicquidDate = function (dateValue) {
        return globalize.format(dateValue, constants.licquidDateFormat);
    };

    Formatter.prototype.parseDate = function (value) {
        return globalize.parseDate(value, [this.dateFormat, this.looseDateFormat]);
    };

    Formatter.prototype.parseLicquidDate = function (value) {
        return globalize.parseDate(value, constants.licquidDateFormat);
    };

    // e.g. if the format is dd/MM/yyyy and we type in 01012012, we'll get 01/01/2012
    Formatter.prototype.properlyFormatDate = function (value) {
        var self = this;
        var theDate = self.parseDate(value);

        if (!theDate)
            return null;

        return self.formatDate(theDate);
    };

    Formatter.prototype.formatDate = function (theDate) {
        return globalize.format(theDate, this.dateFormat);
    };

    Formatter.prototype.getNumberFormat = function () {
        return this.decimalPrecision === 0
            ? constants.valueTypes.integer
            : constants.valueTypes.decimal;
    };

    return Formatter;
});
